function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M69.7,138.7V128H75c1.7,0,3-1.3,3-3v-16.7c0-1.7-1.3-3-3-3h-5.3V94.7H75c1.7,0,3-1.3,3-3v-8.1 c0.8-4.5,3.1-8.8,5-10.6c0.1-0.1,0.2-0.2,0.3-0.4c4.2-5.8,10-8.5,14.2-9.7c2.4-0.7,4.9-1,7.4-1c3.2,0,6.2,0.6,8.9,1.8 c4.5,1.9,8.3,4.9,11.1,8.7l-8.9,5.2c-1.3-1.6-3.3-2.8-5.5-3.6c-1.8-1.1-3.9-1.7-6.2-1.7c-1.3,0-2.7,0.2-3.9,0.6 c-3.5,0.3-6.4,3.1-8.3,5c-2.5,2.5-3.4,6.7-3.4,9.6v4.2c0,1.7,1.3,3,3,3h22v10.7h-22c-1.7,0-3,1.3-3,3V125c0,1.7,1.3,3,3,3h38.7v10.7 H69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M100,181.3c-44.8,0-81.3-36.5-81.3-81.3S55.2,18.7,100,18.7s81.3,36.5,81.3,81.3 S144.8,181.3,100,181.3z M100,31.3c-37.9,0-68.7,30.8-68.7,68.7s30.8,68.7,68.7,68.7s68.7-30.8,68.7-68.7S137.9,31.3,100,31.3z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.1f8389286194c00611da9161d9596d80.svg";
export { ForwardRef as ReactComponent };